import { Injectable } from '@angular/core';
import type { Logger, LogLevelDesc, LoggingMethod } from 'loglevel';
import log from 'loglevel';

import { environment } from '../../env';

@Injectable({ providedIn: 'root' })
export class LoglevelLoggerFactoryService {
  private configured = false;

  create(context: string): Logger {
    this.ensureConfigured();

    const logger = log.getLogger(context);

    // Ensure it uses the same level (and thus same enabled methods)
    logger.setLevel(this.getConfiguredLevel());

    return logger;
  }

  createForClass(clazz: Function): Logger {
    return this.create(clazz?.name ?? 'Unknown');
  }

  private ensureConfigured(): void {
    if (this.configured) return;
    this.configured = true;

    const level = this.getConfiguredLevel();

    // 1) Install prefixing methodFactory ONCE (affects root + named loggers)
    const originalFactory = log.methodFactory;

    log.methodFactory = (methodName, logLevel, loggerName) => {
      const raw = originalFactory(methodName, logLevel, loggerName) as unknown as (...args: any[]) => void;

      let name = typeof loggerName === 'string' && loggerName.length > 0 ? loggerName : 'root';

      if (name.startsWith('_')) {
        name = name.replace(/^_+/, '');
      }

      const wrapped: LoggingMethod = (...args: any[]) => raw(`[${name}]`, ...args);
      return wrapped;
    };

    // 2) Now apply level (IMPORTANT: setLevel after methodFactory)
    log.setLevel(level);
  }

  private getConfiguredLevel(): LogLevelDesc {
    const cfg = (environment as any)?.logging;
    return (cfg?.level ?? 'warn') as LogLevelDesc;
  }
}
